module.exports = __webpack_public_path__ + "img/logo.4e5e5f24.png";